// @flow

import * as React from 'react';
import { Box } from 'grommet';
import styled, { css } from 'styled-components';

type Props = {
    value: string;
};

const ColorBox = styled(Box)`
    border-color: #6e7482;
    position: relative;
    width: 100px;
    height: 20px;
    ${(props) => css`
        background-color: ${props.color};
    `}
`;

const ColorColumn = (props: Props) => {
    const { value } = props;
    return <ColorBox color={value} />;
};

export default ColorColumn;
